export default __webpack_public_path__ + "static/media/more1.224bbc08.png";